"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var models_1 = require("../models");
var ValidationHelper = /** @class */ (function () {
    function ValidationHelper(validationResults) {
        var _this = this;
        this.validationResults = {};
        this.validationResults = validationResults || {};
        this.NormalizeKey = this.NormalizeKey.bind(this);
        var keys = lodash_1.default.keys(this.validationResults);
        this.keys = {};
        lodash_1.default.each(keys, function (key) { return (_this.keys[_this.NormalizeKey(key)] = key); });
    }
    ValidationHelper.prototype.NormalizeKey = function (key) {
        return key.toString().toLowerCase();
    };
    ValidationHelper.prototype.GetKey = function (normalizedKey) {
        return this.keys[normalizedKey];
    };
    ValidationHelper.prototype.IsValid = function (key) {
        if (!key) {
            return lodash_1.default.every(this.validationResults, function (vr) { return vr.isValid; });
        }
        var normalizedKey = this.NormalizeKey(key);
        var referenceKey = this.GetKey(normalizedKey);
        if (lodash_1.default.has(this.keys, normalizedKey)) {
            return this.validationResults[referenceKey].isValid;
        }
        return true;
    };
    ValidationHelper.prototype.Errors = function (key) {
        var normalizedKey = this.NormalizeKey(key);
        var referenceKey = this.GetKey(normalizedKey);
        if (lodash_1.default.has(this.keys, normalizedKey)) {
            return this.validationResults[referenceKey].errors || [];
        }
        return [];
    };
    ValidationHelper.prototype.GetValidationMessages = function (type) {
        var _this = this;
        if (lodash_1.default.isEmpty(this.validationResults)) {
            return [];
        }
        var messages = [];
        switch (type) {
            case models_1.SeverityType.Error:
                Object.keys(this.validationResults).forEach(function (key) {
                    var errors = _this.validationResults[key].errors;
                    if (errors !== undefined && errors.length > 0) {
                        messages = messages.concat(errors);
                    }
                });
                break;
            case models_1.SeverityType.Warning:
                Object.keys(this.validationResults).forEach(function (key) {
                    var warnings = _this.validationResults[key].warnings;
                    if (warnings !== undefined && warnings.length > 0) {
                        messages = messages.concat(warnings);
                    }
                });
                break;
        }
        return messages;
    };
    ValidationHelper.prototype.GetValidationResultForProperty = function (property) {
        var normalizedKey = this.NormalizeKey(property);
        var key = this.GetKey(normalizedKey);
        if (Object.prototype.hasOwnProperty.call(this.validationResults, key)) {
            return this.validationResults[key];
        }
        return undefined;
    };
    return ValidationHelper;
}());
exports.ValidationHelper = ValidationHelper;
